module.exports = __webpack_public_path__ + "img/G - 02.64834b5e.png";